// @ts-nocheck

import { createAsyncThunk } from '@reduxjs/toolkit';
import { onChangeStudio } from '../on-change-studio/on-change-studio';

export const onChangeModel = createAsyncThunk(
  'onChangeModel',
  async (
    data: { modelOdooId: string; configId: string },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    const configurationPack = getState().upsell.configurationsPack.find(
      (item: any) => item.initialConfig.id === data.configId
    );

    if (
      data.modelOdooId !==
      configurationPack.editableConfig.chosenStudioList.studio.model.odooId
    ) {
      const finishOdooId =
        configurationPack.editableConfig.chosenStudioList.studio.finish.odooId;
      const equipmentOdooId =
        configurationPack.editableConfig.chosenStudioList.studio.equipment
          .odooId;

      dispatch(
        onChangeStudio({
          origin: 'onChangeModel',
          modelOdooId: data.modelOdooId,
          finishOdooId,
          equipmentOdooId,
          configId: data.configId,
        })
      );

      return true;
    }
  }
);
